import React, { FC } from "react";
import { TabContext as MuiTabContext } from "@mui/lab";

type Props = React.ComponentProps<typeof MuiTabContext>;

const TabContext: FC<Props> = (props) => {
    return <MuiTabContext {...props}/>
}

export default TabContext;